export const enum QuantityType {
  IMPERIAL = "IMPERIAL",
  INTERNATIONAL = "INTERNATIONAL",
  COMPUTER = "COMPUTER",
}
